import { render, staticRenderFns } from "./driverDetail.vue?vue&type=template&id=5ee93213&"
import script from "./driverDetail.vue.js?vue&type=script&lang=js&"
export * from "./driverDetail.vue.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports